import ProjectDetails from "./ProjectDetails"
// import ProjectBankAccountUpdateModal from "./ProjectBankAccount/ProjectBankAccountUpdateModal"
import ProjectDetailsContext, { useProjectDetailsContext } from "./ProjectDetailsContext"

export default ProjectDetails

export {
  ProjectDetails,
  ProjectDetailsContext,
  useProjectDetailsContext,
  // ProjectBankAccountUpdateModal
}
